var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var LOCATION_TEXTS = 10;
/** Exported only for tests */
var Reader = /** @class */ (function () {
    function Reader(data) {
        this.data = data;
        this.i = 0;
    }
    Reader.prototype.int32 = function () {
        var result = this.data.readInt32LE(this.i);
        /*
            this.data[this.i] +
                          this.data[this.i + 1] * 0x100 +
                        this.data[this.i + 2] * 0x10000 +
                        this.data[this.i + 3] * 0x1000000;
                        */
        this.i += 4;
        return result;
    };
    Reader.prototype.readString = function (canBeUndefined) {
        if (canBeUndefined === void 0) { canBeUndefined = false; }
        var ifString = this.int32();
        if (ifString) {
            var strLen = this.int32();
            var str = this.data.slice(this.i, this.i + strLen * 2).toString("utf16le");
            this.i += strLen * 2;
            return str;
        }
        else {
            return canBeUndefined ? undefined : "";
        }
    };
    Reader.prototype.byte = function () {
        return this.data[this.i++];
    };
    Reader.prototype.dwordFlag = function (expected) {
        var val = this.int32();
        if (expected !== undefined && val !== expected) {
            throw new Error("Expecting " + expected + ", but get " + val + " at position " + (this.i - 4));
        }
    };
    Reader.prototype.float64 = function () {
        var val = this.data.readDoubleLE(this.i);
        this.i += 8;
        return val;
    };
    Reader.prototype.seek = function (n) {
        this.i += n;
    };
    Reader.prototype.isNotEnd = function () {
        if (this.data.length === this.i) {
            return undefined;
        }
        else {
            return ("Not an end! We are at " +
                ("0x" + Number(this.i).toString(16) + ", file len=0x" + Number(this.data.length).toString(16) + " ") +
                (" left=0x" + Number(this.data.length - this.i).toString(16)));
        }
    };
    Reader.prototype.debugShowHex = function (n) {
        if (n === void 0) { n = 300; }
        console.info("Data at 0x" + Number(this.i).toString(16) + "\n");
        var s = "";
        for (var i = 0; i < n; i++) {
            s = s + ("0" + Number(this.data[this.i + i]).toString(16)).slice(-2) + ":";
            if (i % 16 === 15) {
                s = s + "\n";
            }
        }
        console.info(s);
    };
    return Reader;
}());
export { Reader };
var PlayerRace;
(function (PlayerRace) {
    PlayerRace[PlayerRace["\u041C\u0430\u043B\u043E\u043A\u0438"] = 1] = "\u041C\u0430\u043B\u043E\u043A\u0438";
    PlayerRace[PlayerRace["\u041F\u0435\u043B\u0435\u043D\u0433\u0438"] = 2] = "\u041F\u0435\u043B\u0435\u043D\u0433\u0438";
    PlayerRace[PlayerRace["\u041B\u044E\u0434\u0438"] = 4] = "\u041B\u044E\u0434\u0438";
    PlayerRace[PlayerRace["\u0424\u0435\u044F\u043D\u0435"] = 8] = "\u0424\u0435\u044F\u043D\u0435";
    PlayerRace[PlayerRace["\u0413\u0430\u0430\u043B\u044C\u0446\u044B"] = 16] = "\u0413\u0430\u0430\u043B\u044C\u0446\u044B";
})(PlayerRace || (PlayerRace = {}));
var PlanetRace;
(function (PlanetRace) {
    PlanetRace[PlanetRace["\u041C\u0430\u043B\u043E\u043A\u0438"] = 1] = "\u041C\u0430\u043B\u043E\u043A\u0438";
    PlanetRace[PlanetRace["\u041F\u0435\u043B\u0435\u043D\u0433\u0438"] = 2] = "\u041F\u0435\u043B\u0435\u043D\u0433\u0438";
    PlanetRace[PlanetRace["\u041B\u044E\u0434\u0438"] = 4] = "\u041B\u044E\u0434\u0438";
    PlanetRace[PlanetRace["\u0424\u0435\u044F\u043D\u0435"] = 8] = "\u0424\u0435\u044F\u043D\u0435";
    PlanetRace[PlanetRace["\u0413\u0430\u0430\u043B\u044C\u0446\u044B"] = 16] = "\u0413\u0430\u0430\u043B\u044C\u0446\u044B";
    PlanetRace[PlanetRace["\u041D\u0435\u0437\u0430\u0441\u0435\u043B\u0435\u043D\u043D\u0430\u044F"] = 64] = "\u041D\u0435\u0437\u0430\u0441\u0435\u043B\u0435\u043D\u043D\u0430\u044F";
})(PlanetRace || (PlanetRace = {}));
export var WhenDone;
(function (WhenDone) {
    WhenDone[WhenDone["OnReturn"] = 0] = "OnReturn";
    WhenDone[WhenDone["OnFinish"] = 1] = "OnFinish";
})(WhenDone || (WhenDone = {}));
export var PlayerCareer;
(function (PlayerCareer) {
    PlayerCareer[PlayerCareer["\u0422\u043E\u0440\u0433\u043E\u0432\u0435\u0446"] = 1] = "\u0422\u043E\u0440\u0433\u043E\u0432\u0435\u0446";
    PlayerCareer[PlayerCareer["\u041F\u0438\u0440\u0430\u0442"] = 2] = "\u041F\u0438\u0440\u0430\u0442";
    PlayerCareer[PlayerCareer["\u0412\u043E\u0438\u043D"] = 4] = "\u0412\u043E\u0438\u043D";
})(PlayerCareer || (PlayerCareer = {}));
// Gladiator: ......C8
// Ivan:      ......D0
// FullRing   ......CA
// Jump       00000000
//
export var HEADER_QM_2 = 0x423a35d2; // 24 parameters
export var HEADER_QM_3 = 0x423a35d3; // 48 parameters
export var HEADER_QM_4 = 0x423a35d4; // 96 parameters
export var HEADER_QMM_6 = 0x423a35d6;
export var HEADER_QMM_7 = 0x423a35d7;
/**
 *
 * This is a workaround to tell player to keep old TGE behavior if quest is
 * resaved as new version.
 *
 *
 * 0x423a35d7 = 1111111127
 * 0x69f6bd7  = 0111111127
 */
export var HEADER_QMM_7_WITH_OLD_TGE_BEHAVIOUR = 0x69f6bd7;
function parseBase(r, header) {
    if (header === HEADER_QMM_6 ||
        header === HEADER_QMM_7 ||
        header === HEADER_QMM_7_WITH_OLD_TGE_BEHAVIOUR) {
        var majorVersion = header === HEADER_QMM_7 || header === HEADER_QMM_7_WITH_OLD_TGE_BEHAVIOUR
            ? r.int32()
            : undefined;
        var minorVersion = header === HEADER_QMM_7 || header === HEADER_QMM_7_WITH_OLD_TGE_BEHAVIOUR
            ? r.int32()
            : undefined;
        var changeLogString = header === HEADER_QMM_7 || header === HEADER_QMM_7_WITH_OLD_TGE_BEHAVIOUR
            ? r.readString(true)
            : undefined;
        var givingRace = r.byte();
        var whenDone = r.byte();
        var planetRace = r.byte();
        var playerCareer = r.byte();
        var playerRace = r.byte();
        var reputationChange = r.int32();
        var screenSizeX = r.int32(); // In pixels
        var screenSizeY = r.int32(); // In pixels
        var widthSize = r.int32(); // Grid width, from small to big 1E-16-0F-0A
        var heightSize = r.int32(); // Grid heigth, from small to big 18-12-0C-08
        var defaultJumpCountLimit = r.int32();
        var hardness = r.int32();
        var paramsCount = r.int32();
        return {
            givingRace: givingRace,
            whenDone: whenDone,
            planetRace: planetRace,
            playerCareer: playerCareer,
            playerRace: playerRace,
            defaultJumpCountLimit: defaultJumpCountLimit,
            hardness: hardness,
            paramsCount: paramsCount,
            changeLogString: changeLogString,
            majorVersion: majorVersion,
            minorVersion: minorVersion,
            screenSizeX: screenSizeX,
            screenSizeY: screenSizeY,
            reputationChange: reputationChange,
            widthSize: widthSize,
            heightSize: heightSize,
        };
    }
    else {
        var paramsCount = header === HEADER_QM_3
            ? 48
            : header === HEADER_QM_2
                ? 24
                : header === HEADER_QM_4
                    ? 96
                    : undefined;
        if (!paramsCount) {
            throw new Error("Unknown header " + header);
        }
        r.dwordFlag();
        var givingRace = r.byte();
        var whenDone = r.byte();
        r.dwordFlag();
        var planetRace = r.byte();
        r.dwordFlag();
        var playerCareer = r.byte();
        r.dwordFlag();
        var playerRace = r.byte();
        var reputationChange = r.int32();
        var screenSizeX = r.int32();
        var screenSizeY = r.int32();
        var widthSize = r.int32();
        var heightSize = r.int32();
        r.dwordFlag();
        var defaultJumpCountLimit = r.int32();
        var hardness = r.int32();
        return {
            givingRace: givingRace,
            whenDone: whenDone,
            planetRace: planetRace,
            playerCareer: playerCareer,
            playerRace: playerRace,
            defaultJumpCountLimit: defaultJumpCountLimit,
            hardness: hardness,
            paramsCount: paramsCount,
            reputationChange: reputationChange,
            // TODO
            screenSizeX: screenSizeX,
            screenSizeY: screenSizeY,
            widthSize: widthSize,
            heightSize: heightSize,
        };
    }
}
export var ParamType;
(function (ParamType) {
    ParamType[ParamType["\u041E\u0431\u044B\u0447\u043D\u044B\u0439"] = 0] = "\u041E\u0431\u044B\u0447\u043D\u044B\u0439";
    ParamType[ParamType["\u041F\u0440\u043E\u0432\u0430\u043B\u044C\u043D\u044B\u0439"] = 1] = "\u041F\u0440\u043E\u0432\u0430\u043B\u044C\u043D\u044B\u0439";
    ParamType[ParamType["\u0423\u0441\u043F\u0435\u0448\u043D\u044B\u0439"] = 2] = "\u0423\u0441\u043F\u0435\u0448\u043D\u044B\u0439";
    ParamType[ParamType["\u0421\u043C\u0435\u0440\u0442\u0435\u043B\u044C\u043D\u044B\u0439"] = 3] = "\u0421\u043C\u0435\u0440\u0442\u0435\u043B\u044C\u043D\u044B\u0439";
})(ParamType || (ParamType = {}));
export var ParamCritType;
(function (ParamCritType) {
    ParamCritType[ParamCritType["\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C"] = 0] = "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C";
    ParamCritType[ParamCritType["\u041C\u0438\u043D\u0438\u043C\u0443\u043C"] = 1] = "\u041C\u0438\u043D\u0438\u043C\u0443\u043C";
})(ParamCritType || (ParamCritType = {}));
function parseParam(r) {
    var min = r.int32();
    var max = r.int32();
    r.int32();
    var type = r.byte();
    r.int32();
    var showWhenZero = !!r.byte();
    var critType = r.byte();
    var active = !!r.byte();
    var showingRangesCount = r.int32();
    var isMoney = !!r.byte();
    var name = r.readString();
    var param = {
        min: min,
        max: max,
        type: type,
        showWhenZero: showWhenZero,
        critType: critType,
        active: active,
        // showingRangesCount,
        isMoney: isMoney,
        name: name,
        showingInfo: [],
        starting: "",
        critValueString: "",
        img: undefined,
        sound: undefined,
        track: undefined,
    };
    for (var i = 0; i < showingRangesCount; i++) {
        var from = r.int32();
        var to = r.int32();
        var str = r.readString();
        param.showingInfo.push({
            from: from,
            to: to,
            str: str,
        });
    }
    param.critValueString = r.readString();
    param.starting = r.readString();
    return param;
}
function parseParamQmm(r) {
    var min = r.int32();
    var max = r.int32();
    // console.info(`Param min=${min} max=${max}`)
    var type = r.byte();
    //r.debugShowHex(16);
    var unknown1 = r.byte();
    var unknown2 = r.byte();
    var unknown3 = r.byte();
    if (unknown1 !== 0) {
        console.warn("Unknown1 is params is not zero");
    }
    if (unknown2 !== 0) {
        console.warn("Unknown2 is params is not zero");
    }
    if (unknown3 !== 0) {
        console.warn("Unknown3 is params is not zero");
    }
    var showWhenZero = !!r.byte();
    var critType = r.byte();
    var active = !!r.byte();
    var showingRangesCount = r.int32();
    var isMoney = !!r.byte();
    var name = r.readString();
    var param = {
        min: min,
        max: max,
        type: type,
        showWhenZero: showWhenZero,
        critType: critType,
        active: active,
        // showingRangesCount,
        isMoney: isMoney,
        name: name,
        showingInfo: [],
        starting: "",
        critValueString: "",
        img: undefined,
        sound: undefined,
        track: undefined,
    };
    // console.info(`Ranges=${showingRangesCount}`)
    for (var i = 0; i < showingRangesCount; i++) {
        var from = r.int32();
        var to = r.int32();
        var str = r.readString();
        param.showingInfo.push({
            from: from,
            to: to,
            str: str,
        });
    }
    param.critValueString = r.readString();
    param.img = r.readString(true);
    param.sound = r.readString(true);
    param.track = r.readString(true);
    param.starting = r.readString();
    return param;
}
function parseBase2(r, isQmm) {
    var ToStar = r.readString();
    var Parsec = isQmm ? undefined : r.readString(true);
    var Artefact = isQmm ? undefined : r.readString(true);
    var ToPlanet = r.readString();
    var Date = r.readString();
    var Money = r.readString();
    var FromPlanet = r.readString();
    var FromStar = r.readString();
    var Ranger = r.readString();
    var locationsCount = r.int32();
    var jumpsCount = r.int32();
    var successText = r.readString();
    var taskText = r.readString();
    // tslint:disable-next-line:no-dead-store
    var unknownText = isQmm ? undefined : r.readString();
    return {
        strings: {
            ToStar: ToStar,
            Parsec: Parsec,
            Artefact: Artefact,
            ToPlanet: ToPlanet,
            Date: Date,
            Money: Money,
            FromPlanet: FromPlanet,
            FromStar: FromStar,
            Ranger: Ranger,
        },
        locationsCount: locationsCount,
        jumpsCount: jumpsCount,
        successText: successText,
        taskText: taskText,
    };
}
export var ParameterShowingType;
(function (ParameterShowingType) {
    ParameterShowingType[ParameterShowingType["\u041D\u0435\u0422\u0440\u043E\u0433\u0430\u0442\u044C"] = 0] = "\u041D\u0435\u0422\u0440\u043E\u0433\u0430\u0442\u044C";
    ParameterShowingType[ParameterShowingType["\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C"] = 1] = "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C";
    ParameterShowingType[ParameterShowingType["\u0421\u043A\u0440\u044B\u0442\u044C"] = 2] = "\u0421\u043A\u0440\u044B\u0442\u044C";
})(ParameterShowingType || (ParameterShowingType = {}));
export var ParameterChangeType;
(function (ParameterChangeType) {
    ParameterChangeType[ParameterChangeType["Value"] = 0] = "Value";
    ParameterChangeType[ParameterChangeType["Summ"] = 1] = "Summ";
    ParameterChangeType[ParameterChangeType["Percentage"] = 2] = "Percentage";
    ParameterChangeType[ParameterChangeType["Formula"] = 3] = "Formula";
})(ParameterChangeType || (ParameterChangeType = {}));
export var LocationType;
(function (LocationType) {
    LocationType[LocationType["Ordinary"] = 0] = "Ordinary";
    LocationType[LocationType["Starting"] = 1] = "Starting";
    LocationType[LocationType["Empty"] = 2] = "Empty";
    LocationType[LocationType["Success"] = 3] = "Success";
    LocationType[LocationType["Faily"] = 4] = "Faily";
    LocationType[LocationType["Deadly"] = 5] = "Deadly";
})(LocationType || (LocationType = {}));
function parseLocation(r, paramsCount) {
    var dayPassed = !!r.int32();
    var locX = r.int32();
    var locY = r.int32();
    var id = r.int32();
    var isStarting = !!r.byte();
    var isSuccess = !!r.byte();
    var isFaily = !!r.byte();
    var isFailyDeadly = !!r.byte();
    var isEmpty = !!r.byte();
    var paramsChanges = [];
    for (var i = 0; i < paramsCount; i++) {
        r.seek(12);
        var change = r.int32();
        var showingType = r.byte();
        r.seek(4);
        var isChangePercentage = !!r.byte();
        var isChangeValue = !!r.byte();
        var isChangeFormula = !!r.byte();
        var changingFormula = r.readString();
        r.seek(10);
        var critText = r.readString();
        paramsChanges.push({
            change: change,
            showingType: showingType,
            isChangePercentage: isChangePercentage,
            isChangeValue: isChangeValue,
            isChangeFormula: isChangeFormula,
            changingFormula: changingFormula,
            critText: critText,
            img: undefined,
            track: undefined,
            sound: undefined,
        });
    }
    var texts = [];
    var media = [];
    for (var i = 0; i < LOCATION_TEXTS; i++) {
        texts.push(r.readString());
        media.push({ img: undefined, sound: undefined, track: undefined });
    }
    var isTextByFormula = !!r.byte();
    r.seek(4);
    r.readString();
    r.readString();
    var textSelectFurmula = r.readString();
    return {
        dayPassed: dayPassed,
        id: id,
        isEmpty: isEmpty,
        isFaily: isFaily,
        isFailyDeadly: isFailyDeadly,
        isStarting: isStarting,
        isSuccess: isSuccess,
        paramsChanges: paramsChanges,
        texts: texts,
        media: media,
        isTextByFormula: isTextByFormula,
        textSelectFormula: textSelectFurmula,
        maxVisits: 0,
        locX: locX,
        locY: locY,
    };
}
function parseLocationQmm(r, paramsCount) {
    var dayPassed = !!r.int32();
    var locX = r.int32(); /* In pixels */
    var locY = r.int32(); /* In pixels */
    var id = r.int32();
    var maxVisits = r.int32();
    var type = r.byte();
    var isStarting = type === LocationType.Starting;
    var isSuccess = type === LocationType.Success;
    var isFaily = type === LocationType.Faily;
    var isFailyDeadly = type === LocationType.Deadly;
    var isEmpty = type === LocationType.Empty;
    var paramsChanges = [];
    for (var i = 0; i < paramsCount; i++) {
        paramsChanges.push({
            change: 0,
            showingType: ParameterShowingType.НеТрогать,
            isChangePercentage: false,
            isChangeValue: false,
            isChangeFormula: false,
            changingFormula: "",
            critText: "",
            img: undefined,
            track: undefined,
            sound: undefined,
        });
    }
    var affectedParamsCount = r.int32();
    for (var i = 0; i < affectedParamsCount; i++) {
        var paramN = r.int32();
        var change = r.int32();
        var showingType = r.byte();
        var changeType = r.byte();
        var isChangePercentage = changeType === ParameterChangeType.Percentage;
        var isChangeValue = changeType === ParameterChangeType.Value;
        var isChangeFormula = changeType === ParameterChangeType.Formula;
        var changingFormula = r.readString();
        var critText = r.readString();
        var img = r.readString(true);
        var sound = r.readString(true);
        var track = r.readString(true);
        paramsChanges[paramN - 1] = {
            change: change,
            showingType: showingType,
            isChangePercentage: isChangePercentage,
            isChangeFormula: isChangeFormula,
            isChangeValue: isChangeValue,
            changingFormula: changingFormula,
            critText: critText,
            img: img,
            track: track,
            sound: sound,
        };
    }
    var texts = [];
    var media = [];
    var locationTexts = r.int32();
    for (var i = 0; i < locationTexts; i++) {
        var text = r.readString();
        texts.push(text);
        var img = r.readString(true);
        var sound = r.readString(true);
        var track = r.readString(true);
        media.push({ img: img, track: track, sound: sound });
    }
    var isTextByFormula = !!r.byte();
    var textSelectFurmula = r.readString();
    // console.info(isTextByFormula, textSelectFurmula)
    // r.debugShowHex(0); // must be 3543
    return {
        dayPassed: dayPassed,
        id: id,
        isEmpty: isEmpty,
        isFaily: isFaily,
        isFailyDeadly: isFailyDeadly,
        isStarting: isStarting,
        isSuccess: isSuccess,
        paramsChanges: paramsChanges,
        texts: texts,
        media: media,
        isTextByFormula: isTextByFormula,
        textSelectFormula: textSelectFurmula,
        maxVisits: maxVisits,
        locX: locX,
        locY: locY,
    };
}
function parseJump(r, paramsCount) {
    var priority = r.float64();
    var dayPassed = !!r.int32();
    var id = r.int32();
    var fromLocationId = r.int32();
    var toLocationId = r.int32();
    r.seek(1);
    var alwaysShow = !!r.byte();
    var jumpingCountLimit = r.int32();
    var showingOrder = r.int32();
    var paramsChanges = [];
    var paramsConditions = [];
    for (var i = 0; i < paramsCount; i++) {
        r.seek(4);
        var mustFrom = r.int32();
        var mustTo = r.int32();
        var change = r.int32();
        var showingType = r.int32();
        r.seek(1);
        var isChangePercentage = !!r.byte();
        var isChangeValue = !!r.byte();
        var isChangeFormula = !!r.byte();
        var changingFormula = r.readString();
        var mustEqualValuesCount = r.int32();
        var mustEqualValuesEqual = !!r.byte();
        var mustEqualValues = [];
        //console.info(`mustEqualValuesCount=${mustEqualValuesCount}`)
        for (var ii = 0; ii < mustEqualValuesCount; ii++) {
            mustEqualValues.push(r.int32());
            //  console.info('pushed');
        }
        //console.info(`eq=${mustEqualValuesNotEqual} values = ${mustEqualValues.join(', ')}`)
        var mustModValuesCount = r.int32();
        //console.info(`mustModValuesCount=${mustModValuesCount}`)
        var mustModValuesMod = !!r.byte();
        var mustModValues = [];
        for (var ii = 0; ii < mustModValuesCount; ii++) {
            mustModValues.push(r.int32());
        }
        var critText = r.readString();
        // console.info(`Param ${i} crit text =${critText}`)
        paramsChanges.push({
            change: change,
            showingType: showingType,
            isChangeFormula: isChangeFormula,
            isChangePercentage: isChangePercentage,
            isChangeValue: isChangeValue,
            changingFormula: changingFormula,
            critText: critText,
            img: undefined,
            track: undefined,
            sound: undefined,
        });
        paramsConditions.push({
            mustFrom: mustFrom,
            mustTo: mustTo,
            mustEqualValues: mustEqualValues,
            mustEqualValuesEqual: mustEqualValuesEqual,
            mustModValues: mustModValues,
            mustModValuesMod: mustModValuesMod,
        });
    }
    var formulaToPass = r.readString();
    var text = r.readString();
    var description = r.readString();
    return {
        priority: priority,
        dayPassed: dayPassed,
        id: id,
        fromLocationId: fromLocationId,
        toLocationId: toLocationId,
        alwaysShow: alwaysShow,
        jumpingCountLimit: jumpingCountLimit,
        showingOrder: showingOrder,
        paramsChanges: paramsChanges,
        paramsConditions: paramsConditions,
        formulaToPass: formulaToPass,
        text: text,
        description: description,
        img: undefined,
        track: undefined,
        sound: undefined,
    };
}
function parseJumpQmm(r, paramsCount, questParams) {
    //r.debugShowHex()
    var priority = r.float64();
    var dayPassed = !!r.int32();
    var id = r.int32();
    var fromLocationId = r.int32();
    var toLocationId = r.int32();
    var alwaysShow = !!r.byte();
    var jumpingCountLimit = r.int32();
    var showingOrder = r.int32();
    var paramsChanges = [];
    var paramsConditions = [];
    for (var i = 0; i < paramsCount; i++) {
        paramsChanges.push({
            change: 0,
            showingType: ParameterShowingType.НеТрогать,
            isChangeFormula: false,
            isChangePercentage: false,
            isChangeValue: false,
            changingFormula: "",
            critText: "",
            img: undefined,
            track: undefined,
            sound: undefined,
        });
        paramsConditions.push({
            mustFrom: questParams[i].min,
            mustTo: questParams[i].max,
            mustEqualValues: [],
            mustEqualValuesEqual: false,
            mustModValues: [],
            mustModValuesMod: false,
        });
    }
    var affectedConditionsParamsCount = r.int32();
    for (var i = 0; i < affectedConditionsParamsCount; i++) {
        var paramId = r.int32();
        var mustFrom = r.int32();
        var mustTo = r.int32();
        var mustEqualValuesCount = r.int32();
        var mustEqualValuesEqual = !!r.byte();
        var mustEqualValues = [];
        //console.info(`mustEqualValuesCount=${mustEqualValuesCount}`)
        for (var ii = 0; ii < mustEqualValuesCount; ii++) {
            mustEqualValues.push(r.int32());
            //  console.info('pushed');
        }
        var mustModValuesCount = r.int32();
        var mustModValuesMod = !!r.byte();
        var mustModValues = [];
        for (var ii = 0; ii < mustModValuesCount; ii++) {
            mustModValues.push(r.int32());
        }
        paramsConditions[paramId - 1] = {
            mustFrom: mustFrom,
            mustTo: mustTo,
            mustEqualValues: mustEqualValues,
            mustEqualValuesEqual: mustEqualValuesEqual,
            mustModValues: mustModValues,
            mustModValuesMod: mustModValuesMod,
        };
    }
    var affectedChangeParamsCount = r.int32();
    for (var i = 0; i < affectedChangeParamsCount; i++) {
        var paramId = r.int32();
        var change = r.int32();
        var showingType = r.byte();
        var changingType = r.byte();
        var isChangePercentage = changingType === ParameterChangeType.Percentage;
        var isChangeValue = changingType === ParameterChangeType.Value;
        var isChangeFormula = changingType === ParameterChangeType.Formula;
        var changingFormula = r.readString();
        var critText = r.readString();
        var img_1 = r.readString(true);
        var sound_1 = r.readString(true);
        var track_1 = r.readString(true);
        // console.info(`Param ${i} crit text =${critText}`)
        paramsChanges[paramId - 1] = {
            change: change,
            showingType: showingType,
            isChangeFormula: isChangeFormula,
            isChangePercentage: isChangePercentage,
            isChangeValue: isChangeValue,
            changingFormula: changingFormula,
            critText: critText,
            img: img_1,
            track: track_1,
            sound: sound_1,
        };
    }
    var formulaToPass = r.readString();
    var text = r.readString();
    var description = r.readString();
    var img = r.readString(true);
    var sound = r.readString(true);
    var track = r.readString(true);
    return {
        priority: priority,
        dayPassed: dayPassed,
        id: id,
        fromLocationId: fromLocationId,
        toLocationId: toLocationId,
        alwaysShow: alwaysShow,
        jumpingCountLimit: jumpingCountLimit,
        showingOrder: showingOrder,
        paramsChanges: paramsChanges,
        paramsConditions: paramsConditions,
        formulaToPass: formulaToPass,
        text: text,
        description: description,
        img: img,
        track: track,
        sound: sound,
    };
}
export function parse(data) {
    var r = new Reader(data);
    var header = r.int32();
    var base = parseBase(r, header);
    var isQmm = header === HEADER_QMM_6 ||
        header === HEADER_QMM_7 ||
        header === HEADER_QMM_7_WITH_OLD_TGE_BEHAVIOUR;
    var params = [];
    for (var i = 0; i < base.paramsCount; i++) {
        params.push(isQmm ? parseParamQmm(r) : parseParam(r));
    }
    var base2 = parseBase2(r, isQmm);
    var locations = [];
    for (var i = 0; i < base2.locationsCount; i++) {
        locations.push(isQmm ? parseLocationQmm(r, base.paramsCount) : parseLocation(r, base.paramsCount));
    }
    var jumps = [];
    for (var i = 0; i < base2.jumpsCount; i++) {
        jumps.push(isQmm ? parseJumpQmm(r, base.paramsCount, params) : parseJump(r, base.paramsCount));
    }
    if (r.isNotEnd()) {
        throw new Error(r.isNotEnd());
    }
    var base3 = {
        header: header,
    };
    return __assign(__assign(__assign(__assign({}, base), base2), base3), { params: params,
        locations: locations,
        jumps: jumps });
}
//# sourceMappingURL=data:application/json;base64,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